export default {
    header: {
        company: "Cuprolli Manufacturing srl",
        vatIdLabel: "TVA intra",
        vatId: "RO 35671874",
        regComLabel: "RCS",
        regCom: "J2016000468359",
        addressLabel: "Adresse",
        address1: "Strada Caprioarei 11",
        address2: "307200 Ghiroda, Dép. Timis",
        address3: "Roumanie",
        email: "export@i-struct.eu",
        webLabel: "Web",
        web1: "https://i-struct.fr",
        web2: ""
    },
    dateFormat: "DD.MM.YYYY",
    cifLabel: "TVA intra",
    emailLabel: "E-Mail",
    phoneLabel: "Tél",
    toLabel: "À",
    byLabel: "Présenté par",
    noLabel: "N°",
    offerTitle: "DEVIS",
    quoteTitle: "ESTIMATION",
    imgDisclaimer: "La photo est fournie à titre indicatif uniquement", 
    umLabels: {
        kg: 'kg',
        ml: 'ml',
        m2: 'm²',
        buc: 'pcs',
        h: 'h',
        l: 'L'
    },
    // What a module is called on the offer and in the PDF, keyed by type and variant.
    // framedPanel is a retired type kept for offers that still carry one.
    moduleNames: {
        panel: "Panneau",
        pedestrianGate: "Portail piéton",
        pedestrianGateSidePanel: "Portail piéton avec panneau latéral",
        swingGateSingleLeaf: "Portail battant 1 vantail",
        swingGateDoubleLeaf: "Portail battant 2 vantaux",
        swingGateBiFoldSingle: "Portail battant bi-fold simple",
        swingGateBiFoldDouble: "Portail battant bi-fold double",
        slidingGateSingleLeaf: "Portail coulissant 1 vantail",
        slidingGateDoubleLeaf: "Portail coulissant 2 vantaux",
        slidingGateTelescopic: "Portail coulissant télescopique",
        slidingGateArticulated: "Portail coulissant articulé",
        selfSupportingGate: "Portail autoportant",
        posts: "Poteaux",
        post80: "Poteau 80 × 80 mm",
        post100: "Poteau 100 × 100 mm",
        post200: "Poteau 200 × 100 mm",
        framedPanel: "Panneau de clôture avec cadre"
    },
    moduleLabels: {
        piece: "pcs",
        dimensions: "Dimensions (L x H)",
        area: "Surface",
        slatWidth: "Largeur du profil",
        noProfiles: "Nombre de profils",
        slatDistance: "Distance entre les profils",
        slatDimension: "Dimensions du profil",
        pedestrianGateWidth: "Largeur du portillon",
        height: "Hauteur",
        priceArea: "Prix / m²",
        priceLength: "Prix / ml",
        priceSingle: "Prix unitaire",
        priceTotal: "Montant total"
    },
    totalsLabels: {
        currency: "€",
        total: "TOTAL",
        vatIncluded: "TVA incluse",
        color: "COULEUR",
        montageIncluded: "POSE INCLUSE",
        montageNotIncluded: "SANS POSE",
        measureMontageNotInluded: "SANS PRISE DE MESURES ET POSE",
        price_no_VAT_msg: "Tarifs pour les entreprises assujetties à la TVA avec un code VIES valide",
        price_VAT_msg: "Tarifs pour les particuliers ou les entreprises non assujetties à la TVA"
    },
    features: {
        featuresTitle: "CARACTÉRISTIQUES",
        projectsTitle: "PROJETS RÉALISÉS",
        projectsLink: "https://i-struct.fr/projets",
        list: ["- Profilés en aluminium", "- Laquage électrostatique", "- Peinture thermolaquée", "- Fixation mécanique", "- Sans soudure"]
    },
    extraDetails: {
        title: "Détails supplémentaires",
        payment: "Conditions de paiement",
        upfrontPayment: "d'acompte à la commande",
        extraPayment: "lors des mesures",
        afterPayment: "à l'achèvement de la pose.",
        execution: "Délai d'exécution",
        days: "Jours",
        years: "Ans",
        warranty: "Garantie des travaux",
        validOffer: "Validité du devis",
        montageDate: "Programmation des travaux",
        finalDate: "Achèvement des travaux",
        paymentDisclaimer: ""
    },
    nextPage: "Suite à la page suivante",
}